(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SeekingSettingsDetailController', SeekingSettingsDetailController);

    SeekingSettingsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SeekingSettings', 'GenderEnum'];

    function SeekingSettingsDetailController($scope, $rootScope, $stateParams, previousState, entity, SeekingSettings, GenderEnum) {
        var vm = this;

        vm.seekingSettings = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:seekingSettingsUpdate', function(event, result) {
            vm.seekingSettings = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
